import { interjectResourceString } from './interjectResourceString';
export function pluraliseCount(count, templates) {
    const { singular, plural } = templates;
    return interjectResourceString(count === 1 ? singular : plural, count);
}
